require('./cancelCreditCardRenewal.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utils
const apiURLBuilder = require('core/apiURLBuilder');
// @ commons
const { formatText } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const {WIZARD_VERTICAL_VIEW_MODE} = require('constants/index');

// @components
const CardGenericConfirmationStep = require('components/contactCenter/cardGenericConfirmationStep/cardGenericConfirmationStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const {
    CIC_CHANNEL,
    NO_RENOVAR
} = require('constants/index');
const {
    CANCEL_CREDIT_CARD_RENEWAL
} = require('constants/operationTypes');

class CancelCreditCardRenewal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleFinish(){
        this.props.cancelRenewal(this.props.cardId);
    }

    handleCancel() {
        this.props.history.push(apiURLBuilder.getURL("cardIdUrl", {cardId: this.props.cardId}));
    }

    buildWizard() {
        const { immCard, setVisibleStep, validateStep, immCreditCardRenewalStatus, setWillCancel } = this.props;
        const renewalStatus = immCreditCardRenewalStatus.getIn(['cancelRenewalDetails','descripcionSituaTarjeta']);

        const message = renewalStatus.toUpperCase() === NO_RENOVAR ? 'operativeNameActivation' : 'operativeName';
        const operativeName = formatText(`cancelCreditCardRenewal-${message}`);

        const immSteps = immCreditCardRenewalStatus.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCreditCardRenewalStatus.get('visibleStep');

        const pan = immCard.get('number').replace(/\s/g,'');
        const originAccount =  immCard.get('fullContractNumber').replace(/\s+/g, '');
        const operationType = CANCEL_CREDIT_CARD_RENEWAL

        const operationParams =  {
          "channel": CIC_CHANNEL,
          "pan": pan,
          "originAccount": originAccount
        }

        const actions = {
            setVisibleStep,
            validateStep,
            finish: this.handleFinish,
            setWillCancel : setWillCancel,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                fullWidth={false}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                viewMode={WIZARD_VERTICAL_VIEW_MODE}

                >
                <WizardStep
                    cancelButton={true}
                    isLoading={false}
                    position="first"
                    nextBtnModifier="primary"
                    >
                    <CardGenericConfirmationStep
                        operativeName={operativeName}
                        immCard={immCard}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton="cancelCreditCardRenewal-confirmBtn"
                    omitPreviousButton={true}
                    position="last"
                    nextBtnModifier="primary"
                    >
                    <VerifyOtpStep
                        operationType={operationType}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        const content = this.buildWizard();

        return (
            <div className="cancel-credit-card-renewal">
                {content}
            </div>
        );
    }
}

CancelCreditCardRenewal.propTypes = {
    history: PropTypes.object.isRequired,
    immCreditCardRenewalStatus: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    cancelRenewal:PropTypes.func,
    immCard: PropTypes.object.isRequired,
    cardId: PropTypes.object.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports = withRouter(CancelCreditCardRenewal);
